var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AudienceMockData from './mocks/AudienceMockData.json';
import StudiesMockData from './mocks/StudiesMockData.json';
import StudyMockData from './mocks/StudyMockData.json';
import PendingStudyMockData from './mocks/PendingStudyMockData.json';
import { requestHeaders } from './RequestHeaders';
// Temporary measure while env variables get sorted out
const getBaseUrl = () => {
    return process.env.AI_CREATIVE_SCORING_API_URL || 'http://localhost:8090';
};
export const uploadFile = (file) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (((_a = process.env.MOCK_API_DATA) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true') {
        yield new Promise(resolve => setTimeout(resolve, 4000));
        return { uri: 'https://example.com' };
    }
    const type = (_b = file.name.split('.').pop()) !== null && _b !== void 0 ? _b : '';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    const url = new URL('/api/v1/media/upload', getBaseUrl());
    const response = yield fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
    });
    return response.json();
});
export const deleteFile = (fileName) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        if (((_a = process.env.MOCK_API_DATA) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true') {
            return { message: 'Mocked file delete' };
        }
        const url = new URL(`/api/v1/media/delete/${fileName}`, getBaseUrl());
        const response = yield fetch(url, {
            method: 'DELETE',
            headers: requestHeaders(),
            credentials: 'include',
        });
        if (!response.ok) {
            throw new Error(`Error deleting: ${response.statusText}`);
        }
    }
    catch (error) {
        throw new Error(`Error deleting the item: ${error}`);
    }
});
export const getStudyById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        if (((_a = process.env.MOCK_API_DATA) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true') {
            return new Promise(resolve => setTimeout(() => resolve(StudyMockData), 2000));
        }
        const url = new URL(`/api/v1/studies/${id}`, getBaseUrl());
        const response = yield fetch(url, {
            method: 'GET',
            headers: requestHeaders(),
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error(`Error fetching studies: ${response.statusText}`);
        }
        return response.json();
    }
    catch (error) {
        throw new Error(`Error fetching studies: ${error}`);
    }
});
export const initiateStudy = (body) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        if (((_a = process.env.MOCK_API_DATA) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true') {
            return new Promise(resolve => setTimeout(() => resolve(PendingStudyMockData), 2000));
        }
        const url = new URL('/api/v1/studies', getBaseUrl());
        const response = yield fetch(url, {
            method: 'POST',
            headers: requestHeaders(),
            credentials: 'include',
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            throw new Error(`Error initiating study: ${response.statusText}`);
        }
        return response.json();
    }
    catch (error) {
        throw new Error(`Error initiating study: ${error}`);
    }
});
export const getStudies = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        if (((_a = process.env.MOCK_API_DATA) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true') {
            return new Promise(resolve => setTimeout(() => resolve(StudiesMockData), 2000));
        }
        const url = new URL('/api/v1/studies', getBaseUrl());
        const response = yield fetch(url, {
            method: 'GET',
            headers: requestHeaders(),
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error(`Error fetching studies: ${response.statusText}`);
        }
        return response.json();
    }
    catch (error) {
        throw new Error(`Error fetching studies: ${error}`);
    }
});
export const fetchAudiences = (query) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        if (((_a = process.env.MOCK_API_DATA) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true') {
            const audienceFilter = AudienceMockData;
            return new Promise(resolve => setTimeout(() => resolve(audienceFilter), 2000));
        }
        const url = new URL('/api/v1/taxonomies', getBaseUrl());
        if (query) {
            url.searchParams.set('q', query);
        }
        url.searchParams.set('max-results', '10');
        const response = yield fetch(url, {
            method: 'GET',
            headers: requestHeaders(),
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error(`Error fetching audiences: ${response.statusText}`);
        }
        return response.json();
    }
    catch (error) {
        throw new Error(`Error fetching audiences: ${error}`);
    }
});
